import {CustomerType} from 'constants/flow/flowTypesCheckout';
import {ActiveSortType} from 'constants/flow/flowTypes';
import {
    CategoryItemsDataType,
    CategoryDataForGlobalDataLayerType,
} from 'constants/flow/flowTypesGlobalDataLayer';

import {CategoryType} from 'reducers/category/categoryType';
import {
    CategoryMsWindowProductType,
    CategoryProductFrameType,
} from 'reducers/category/categoryItemsType';

import {
    emptyStringIsFalsy,
    arrayToString,
    getSecondImageValue,
    getAttributeBoolean,
    getColorIds,
    getFrameSizeAsArrayOrNull,
} from '../../helpers';

/**
 * Prepare category data.
 *
 * @param {CustomerType} customer - Customer data.
 * @returns {CategoryItemsDataType} - Returned product data prepared for Global Data Layer.
 */
export const prepareCategoryData = (customer: CustomerType) => (
    product: CategoryMsWindowProductType,
): CategoryItemsDataType => {
    const [children] = product.children;
    return {
        attribute_set: getAttributeBoolean(children.isContactLenses),
        product_id: emptyStringIsFalsy(product.id),
        glasses_type: '',
        brand: emptyStringIsFalsy(children.brand.label),
        color: getColorIds(children),
        frame_url_path: emptyStringIsFalsy(children.url),
        gender: arrayToString(children.genders),
        final_price: children.finalPrice,
        image_1_url_path: '',
        image_2_url_path: getSecondImageValue(children),
        image_3_url_path: '',
        lens_type: arrayToString((children as CategoryProductFrameType).lensTypeIds),
        page_name: emptyStringIsFalsy(product.name),
        page_url: `${window.location.origin}/${emptyStringIsFalsy(children.url)}`,
        previous_category_id: emptyStringIsFalsy(customer.previous_category_id),
        previous_category_name: emptyStringIsFalsy(customer.previous_category_name),
        product_name: emptyStringIsFalsy(children.name),
        // TODO: to ANT-team - we put a frame size id in the array to match the old structure,
        //  probably it should be refactored
        size: getFrameSizeAsArrayOrNull(children) || '',
        sku: emptyStringIsFalsy(children.sku),
        window_name: emptyStringIsFalsy(product.name),
        product_badge: arrayToString(children?.badges?.map(({id}) => id)),
    };
};

/**
 * Get fields for Global Data Layer for category page.
 * @namespace
 * @property {CustomerType} customer - customer data
 * @property {CategoryType} category - category data
 * @property {ActiveSortType} activeSort - activeSort active category
 * @property {Array<CategoryProductType>} products - category items
 * @returns {CategoryDataForGlobalDataLayerType} - returned category data prepared for Global Data Layer.
 */
export function getCategoryDataGlobalDataLayer({
    customer,
    category,
    activeSort,
    products,
}: {
    customer: CustomerType;
    category: CategoryType;
    activeSort: ActiveSortType;
    products: CategoryMsWindowProductType[];
}): CategoryDataForGlobalDataLayerType {
    return {
        category_id: category.id,
        sorting_criteria: activeSort.name || 'weighted',
        sorting_order: activeSort.value || 'asc',
        category_name: category.title,
        page_type_param1: 'CATEGORY',
        page_type_param2: 'CATEGORY',
        products: products.map(prepareCategoryData(customer)),
    };
}
